export enum PaymentsType {
    all = 'all',
    ecom = 'ecom',
    pos = 'pos'
}
